import { useCallback } from 'react'

import { useFetchGroupUsersApi } from 'api/groups/queryFetchers/useFetchGroupUsersApi'
import { TableInfiniteLoader } from 'components/common/table'
import { TableDefaults } from 'constants/table'
import { useUsersAdditionalDataForLoader } from 'hooks/useUsersAdditionalData'
import { GroupUser } from 'types/groups/groups'

interface Params {
  groupId: string
  search?: string
}

export const useGroupUsersListLoader = ({ search, groupId }: Params) => {
  const handleFetchGroupsList = useFetchGroupUsersApi({
    staleTime: TableDefaults.LoaderStaleTime,
  })
  const handleUsersAdditionalData = useUsersAdditionalDataForLoader()

  const loader: TableInfiniteLoader<GroupUser> = useCallback(async () => {
    const { data: members } = await handleFetchGroupsList({
      search,
      groupId,
    })

    const usersAdditionalData = await handleUsersAdditionalData(members)

    return {
      data: members.map(member => {
        const mappedUser = usersAdditionalData.get(member.email)
        return {
          ...member,
          isExternal: Boolean(mappedUser?.isExternal),
          synced: mappedUser?.synced,
          ...(mappedUser && { first_name: mappedUser.firstname, last_name: mappedUser.lastname }),
        }
      }),
      totalRowsCount: members.length,
    }
  }, [groupId, handleFetchGroupsList, search, handleUsersAdditionalData])

  return { loader }
}
